// extracted by mini-css-extract-plugin
export default {"error404Component":"Error404_error404Component__7jaDG"};